import { LegacyRef } from 'react';
import { ButtonProps } from '../Button/ButtonCore/ButtonCore';
import { ValuesOf } from '../utils/typeUtils';
import { SIZES } from './FillPreview.constants';

export type FillPreviewProps = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook?: string;
  /** Specifies a CSS class name to be appended to the component’s root element.
   * @internal
   */
  className?: string;
  /** Specify a color, gradient, image URL, SVG or a list of colors to be rendered as a preview content. */
  fill?: React.ReactNode;
  /** Specifies whether preview is selected or not. Selected item receives an outline border style. */
  selected?: boolean;
  /** Specify whether preview should be disabled or not */
  disabled?: boolean;
  /** Control elements aspect ratio value  */
  aspectRatio?: string | number;
  /**
   * Controls the size of the element.
   */
  size?: FillPreviewSize;
  ref?: LegacyRef<HTMLDivElement>;
} & ButtonProps;

export type FillPreviewSize = ValuesOf<typeof SIZES>;
